import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-steel px-5 py-10" data-id="element-150" data-mp="3fyhq1vsbkxc4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-151" data-mp="2eta8kamjoejg">
        <p className="text-sm font-semibold text-white sm:text-base" data-id="element-152" data-mp="29u5zdjzmegt4">
          <span className="tracking-tight text-gold" data-id="element-153" data-mp="29scpzwxmhihf">⭐⭐⭐⭐⭐</span> 4.9/5 · Trusted by 500+ ESL
          teachers across 7 countries
        </p>
      </div>
    </section>;
}